export default "__VITE_ASSET__29po0I8X__"